export { default as I18nPropvider } from './Provider';
export { LOCALES } from './constants';
// export { default as getLocale } from './getLocale';
